/**
 * Handles s geometry data.
 */
export abstract class HsGeometryData {
  constructor(public vertices: ArrayLike<number>, public normals: ArrayLike<number>, public uvs?: ArrayLike<number>) {}
}
